export default {
    data: () => {
        return {
        }
    },
    methods: {
        loc (key, locale = 'ru') {
            const locales = {
                ru: {
                    login_page_title: 'Войти',
                    register_page_title: 'Регистрация',
                    home_page_title: 'Салем!',

                    my_offers_page_title: 'Мои заявки',
                    offers_create_page_title: 'Добавить',
                    transporter_offers_active_page_title: 'Попутки',

                    passenger_offers_active_page_title: 'Попутчики',

                    account_page_title: 'Личный кабинет',
                    
                    login_btn: 'Войти',
                    register_btn: 'Регистрация',
                    'Регистрация в системе': 'Регистрация в системе',
                    email_full: 'Адрес электронной почты',

                    passenger: 'пассажир',
                    transporter: 'перевозчик',
                    
                    no_active_offers:'Попуток пока нет',
                    no_active_passenger_offers:'Попутчиков пока нет',
                }
            }
            return locales[locale][key] !== undefined ? locales[locale][key] : key 
        }
    }
}
